export const VIEW_AS_QUERY_PARAM = 'view_as';

export const SUPPORTED_CERT_EXTENSIONS = ['.crt', '.cer', '.p7b', '.p7c', '.p7s', '.pem', '.key'];

export const TRANSACTION_THRESHOLD_LIMIT = 90;

//.key extension is here to allow user to use CLIENT_KEYSTORE_TRUSTORE usage type
export const SUPPORTED_KEYSTORES = ['.jks', '.keystore', '.key'];

//TODO - use enumeration instead of string constants
export const PROVIDER_CLOUD = 'Google Cloud Platform';
export const PROVIDER_OPL = 'Private Locations';
